/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { SolanaNFTSelector, SolanaNFTTypes } from 'store'
import {
  getSolanaNFtCollections,
  updateMagicEdenSlug,
  deleteMagicEdenSlug,
  setCollectionInactive,
} from 'services'
import { SolanaNFTCollectionFormModal, SolanaNFTCollectionList } from 'features'

import MainLayout from 'components/layouts/main'
import ArchiveDialog from 'components/commons/dialog/archive'
import { notifySuccess, notifyError } from 'components/commons/toast'

import { ToastContainer } from 'react-toastify'
import { responseMessage } from 'constant'
import Button from 'components/commons/button'

const SolanaNFTPage = () => {
  const {
    collection = [],
    limit,
    isRequesting,
    hasDataToLoad,
    orderRef,
    order,
  } = useSelector(SolanaNFTSelector)

  const [archive, setArchive] = useState({
    show: false,
    collection: null,
  })

  const [slugForm, setSlugForm] = useState({
    show: false,
    collection: null,
  })

  const dispatch = useDispatch()

  useEffect(() => {
    getCollections({
      displayLoader: true,
    })

    return () => {
      setArchive({
        show: false,
        collection: null,
      })
      setSlugForm({
        show: false,
        collection: null,
      })
    }
  }, [])

  const getCollections = ({ displayLoader = true }) => {
    if (isRequesting || !hasDataToLoad) {
      return false
    }

    dispatch({
      type: SolanaNFTTypes.GET_SOLANA_NFT_DATA,
      payload: { loading: displayLoader },
    })

    setTimeout(() => {
      getSolanaNFtCollections({ limit, order, orderRef }).then((payload) => {
        dispatch({
          type: SolanaNFTTypes.SET_SOLANA_NFT_DATA,
          payload,
        })
      })
    }, 1250)
  }

  const closeModal = (modal: string) => {
    if (modal === 'form-modal') {
      setSlugForm({
        show: false,
        collection: null,
      })
    } else if (modal === 'archive-dialog') {
      setArchive({
        show: false,
        collection: null,
      })
    }
  }

  const onEnterSlug = (collection: any) => {
    setSlugForm({
      show: true,
      collection,
    })
  }

  const saveNewSlug = async (newSlug: string) => {
    if (newSlug) {
      await updateMagicEdenSlug(newSlug, slugForm.collection)
        .then((payload) => {
          closeModal('form-modal')
          notifySuccess(`${responseMessage.successSave} new slug.`)

          dispatch({
            type: SolanaNFTTypes.UPDATE_SOLANA_NFT_COLLECTION,
            payload,
          })
        })
        .catch((error) => {
          console.log(error)
          notifyError(`${responseMessage.errorSave} new slug.`)
        })
    }
  }

  const onArchive = (collection: any) => {
    setArchive({
      show: true,
      collection,
    })
  }

  const submitArchive = async () => {
    const { invalid_magic_eden_slug_id }: any = archive.collection
    await deleteMagicEdenSlug({ id: invalid_magic_eden_slug_id })
      .then((payload) => {
        closeModal('archive-dialog')
        notifySuccess(responseMessage.successArchive)

        dispatch({
          type: SolanaNFTTypes.DELETE_SOLANA_NFT_COLLECTION,
          payload,
        })
      })
      .catch((error) => {
        console.log(error)
        notifyError(responseMessage.errorArchive)
      })
  }

  const setInactive = async (collection: any) => {
    await setCollectionInactive(collection)
      .then((payload) => {
        notifySuccess('Successfully set collection to inactive')

        dispatch({
          type: SolanaNFTTypes.UPDATE_SOLANA_NFT_COLLECTION,
          payload,
        })

        /* setTimeout(() => {
          dispatch({
            type: SolanaNFTTypes.DELETE_SOLANA_NFT_COLLECTION,
            payload,
          })
        }, 500)*/
      })
      .catch((error) => {
        console.log(error)
        notifyError(responseMessage.errorArchive)
      })
  }

  return (
    <React.Fragment>
      <MainLayout>
        <h1 className='font-bold text-4xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
          Invalid Solana NFTs Dashboard
        </h1>

        {slugForm.show && (
          <SolanaNFTCollectionFormModal
            collection={slugForm.collection}
            onSubmit={saveNewSlug}
            onClose={closeModal}
          />
        )}

        {archive.show && <ArchiveDialog onClose={closeModal} onSubmit={submitArchive} />}

        <ToastContainer limit={1} autoClose={3000} />

        <SolanaNFTCollectionList
          {...{
            collection,
            hasDataToLoad,
            isRequesting,
            onEnterSlug,
            onArchive,
            setInactive,
          }}
          onLoadMore={getCollections}
        />
      </MainLayout>
    </React.Fragment>
  )
}

export default SolanaNFTPage
